<script >
export default {
  name: 'MemberUnselectedItem',
  props: {
    index: { // index of current item
      type: Number
    },
    source: { // here is: {uid: 'unique_1', text: 'abc'}
      type: Object,
      default () {
        return {}
      }
    },
    deleteSelect: {
      type: Function,
      default: () => {}
    }
  },
  data() {
    return {
    }
  },
  methods: {
    handleDelete( index){
      // this.$emit('click', index)
      this.deleteSelect(index)
    }
  }
}
</script>

<template>
    <div class="member-selected-item-content">
      <div class="available_frame_select_left">
        <div class="available_depa_left_icon">
          <img src="@/assets/device.png" />
        </div>
        <div>
          <div class="available_frame_tobeselected_name">
            {{ source.name }}
          </div>
          <div class="available_frame_tobeselected_depa">
            {{ source.department }}
          </div>
        </div>
      </div>
      <img
          src="@/assets/close.png"
          class="available_frame_select_right"
          @click="handleDelete(index)"
      />
    </div>
</template>

<style scoped>
.member-selected-item-content {
  display: flex;
  height: 56px;
  align-items: center;
  justify-content: start;
  padding: 0 20px;
  box-sizing: border-box;
  position: relative;
}
.member-selected-item-content .available_frame_select_left {
  display: flex;
  align-items: center;
}
.member-selected-item-content .available_frame_select_left .available_depa_left_icon {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #cbe7ff;
  margin: 0 8px 0 0;
}

.member-selected-item-content .available_frame_select_left .available_depa_left_icon img {
  width: 18px;
  height: 18px;
}
.member-selected-item-content .available_frame_tobeselected_name {
  font-size: 15px;
  color: #1a1a1a;
}
.member-selected-item-content .available_frame_tobeselected_depa {
  font-size: 13px;
  max-width: 100px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  color: rgba(26, 26, 26, 0.6);
}
.member-selected-item-content .available_frame_select_right {
  width: 16px;
  height: 16px;
  cursor: pointer;
  position: absolute;
  right: 5px;
}
</style>